module.exports = __webpack_public_path__ + "static/media/bullet_icon.5f0f109d.svg";